module.exports = "/_next/static/images/Supercharge-cfc5e1bba2bbca21eb8638764510ad04.webp";